/** @flow */
import {
  GetMyNotifications,
  GetMyNotificationsSuccess,
  GetMyNotificationsError,
  SetMyNotificationsSearch,
} from "@modules/reporting/constants/actions";
import { GetEmployeeAbsenceNotificationSuccess } from "@modules/shared/constants/actions";
import * as notificationsReducers from "./reducers";
import initialState from "./state";
import type { NotificationsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: NotificationsState = initialState, action: Object): NotificationsState => {
  const act = {
    [GetMyNotifications]: notificationsReducers.setLoading,
    [GetMyNotificationsSuccess]: notificationsReducers.onGetMyNotificationsSuccess,
    [GetMyNotificationsError]: notificationsReducers.onGetMyNotificationsError,
    [SetMyNotificationsSearch]: notificationsReducers.onSetMyNotificationsSearch,
    [GetEmployeeAbsenceNotificationSuccess]:
      notificationsReducers.onGetEmployeeAbsenceNotificationSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
